
export default {
    head() {
        return {
            title: this.current_category.metatitle ? this.current_category.metatitle : this.current_category.title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.current_category.metadesc,
                }
            ],
        }
    },

    data() {
        return {
            h1: null,
            metatitle: null,
            metadesc: null,

            current_category: null,
            categories: null,
            posts: null,

            active_category: 0,
            page: 1,
            total_pages: null,
        };
    },

    methods: {
        //     setActiveCategory(id) {
        //         this.active_category = id
        //         if (id) {
        //             let category_obj = this.categories.find(category => category.id === id)
        //             this.current_h1 = category_obj.title
        //             history.pushState(null, null, this.localePath('blog') + '/' + category_obj.slug)
        //         } else {
        //             history.pushState(null, null, this.localePath('blog'))
        //             this.current_h1 = this.h1
        //         }
        //     }
        getPosts() {
            this.$axios
                .get('/blog/' + this.$route.params.category, {
                    params: {
                        page: this.page,
                    }
                })
                .then((res) => {
                    if (this.page > 1) {
                        this.posts = this.posts.concat(res.data.posts)
                    }
                    else this.posts = res.data.posts

                    this.total_pages = res.data.total_pages
                })

        },
    },

    asyncData(context) {
        return context.$axios
            .get('/blog/' + context.route.params.category)
            .then((res) => {
                return {
                    current_category: res.data.category,
                    h1: res.data.category.title,
                    metatitle: res.data.category.metatitle,
                    metadesc: res.data.category.metadesc,

                    categories: res.data.categories,
                    posts: res.data.posts,
                    total_pages: res.data.total_pages,
                    active_category: res.data.category.id,
                }
            })
            .catch((e) => {
                context.error({ statusCode: 404 })
            })
    },
}
